import { RouteObject } from "react-router";

import { authCallbackRoute } from "@punto/frontend-shared/providers/auth-callback-route";

import { routePaths } from "@/router/route-paths";

import { lazyRoute } from "./lazy-route";

const Screens = {
  Login: () => import("@/modules/auth/screens/login-screen"),
  Logout: () => import("@/modules/auth/screens/logout-screen"),
};

export const publicRoutes: RouteObject[] = [
  authCallbackRoute,
  {
    path: routePaths.login,
    lazy: lazyRoute(Screens.Login),
  },
  /**
   * Public, as in Janus: logging out is exactly what someone without a usable
   * session needs. Behind the authentication guard it did the opposite — it
   * bounced them into a login, which is how it came to be the one route that
   * could not get them out of a failing one (P-2726).
   */
  {
    path: routePaths.logout,
    lazy: lazyRoute(Screens.Logout),
  },
];
